import React from "react";
import { Card, CardContent, Chip } from "@material-ui/core";
import { formatPrice } from "../../../utils/formatPrice";

const TransactionInfoCard = ({ item }) => {
  // Determine if the transaction is credit or debit
  const isCredit = item?.transaction_type === "credit";
  const isDebit = item?.transaction_type === "debit";

  return (
    <Card
      style={{
        borderLeft: `5px solid ${isCredit ? "green" : "red"}`,
      }}
    >
      <CardContent>
        <div className="box">
          <div className="box-title">
            <div className="row align-item-center">
              <div className="col-md-6">
                <div className="d-flex flex-column" style={{ gap: 5 }}>
                  <h3>Transaction ID &mdash; {item?.transaction_number}</h3>
                  <h3>Transaction Type &mdash; {item?.transaction_type}</h3>
                  <h3>
                    Transaction Date &mdash;
                    {new Date(item.transaction_date).toLocaleString()}
                  </h3>
                  {isDebit && (
                    <>
                      <h6>
                        Receiving Type &mdash; {item?.payment_receiving_type}
                      </h6>
                      <h6>
                        Status &mdash;
                        <Chip
                          className="text-capitalize"
                          label={item?.status}
                          size="small"
                          variant="outlined"
                          color={
                            item?.status === "pending"
                              ? "info"
                              : item?.status === "accepted"
                              ? "primary"
                              : "secondary"
                          }
                        />
                      </h6>
                    </>
                  )}
                </div>
              </div>
              <div className="col-6" style={{ textAlign: "end" }}>
                <h2>
                  {isCredit ? (
                    <h2 style={{ color: "green" }}>
                      + {formatPrice(item.amount.toFixed(2))}
                    </h2>
                  ) : (
                    <h2 style={{ color: "red" }}>
                      - {formatPrice(item.amount.toFixed(2))}
                    </h2>
                  )}
                </h2>
              </div>
            </div>
          </div>
          <div className="box-content">
            <div className="d-flex flex-column">
              {item?.order && (
                <>
                  <small className="text-muted">
                    Order ID &mdash; {item?.order?.order_track_id}
                  </small>
                  <small className="text-muted">
                    Order Price &mdash; {formatPrice(item?.order?.total_price)}
                  </small>
                </>
              )}
              <small className="text-muted">
                User &mdash; {item?.user?.first_name} {item?.user?.last_name} (
                {item?.user?.role})
              </small>
              <small>Program &mdash; {item?.payment_source}</small>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TransactionInfoCard;
